import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "font-montserrat font-12" }
const _hoisted_2 = { class: "text-start font-montserrat-bold font-15 layout_blue" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "icon_layout_title",
  src: "/assets/icon/meus_pedidos-cart.svg"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Detalhes dos itens ")
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  class: "ion-text-center text-start font-montserrat font-11",
  size: "12"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Comprar Novamente ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  class: "icon_layout_title",
  src: "/assets/icon/lojas.svg"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode()
const _hoisted_10 = { class: "font-montserrat-bold" }
const _hoisted_11 = { class: "text-start font-montserrat" }
const _hoisted_12 = {
  key: 0,
  class: "text-start font-montserrat"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  class: "icon_layout_title",
  src: "/assets/icon/carteira.svg"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Pagamento ")
const _hoisted_16 = { class: "font-montserrat ion-text-end" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  class: "icon_layout_title",
  src: "/assets/icon/resumo.svg"
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Resumo do Pedido ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Sub Total ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Taxa Entrega ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Total ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Avaliação ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Como você avalia esse pedido? ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Como você avalia esse aplicativo? ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_col, {
          class: "ion-text-center font-montserrat-bold layout_blue font-25",
          size: "12"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Pedido #" + _toDisplayString(_ctx.pedido.order_no), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_col, { size: "6" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_badge, { color: "jauservelayoutalter" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.pedido.shipments[0].shipping_method.name), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ion_col, { size: "6" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.toDiaMes(_ctx.pedido.c_windowStartTime)) + " das " + _toDisplayString(_ctx.toHora(_ctx.pedido.c_windowStartTime)) + " às " + _toDisplayString(_ctx.toHora(_ctx.pedido.c_windowEndTime)), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_col, {
          class: "bold font-montserrat-bold layout_blue",
          size: "10"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_ion_col, { size: "2" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_badge, { color: "jauservelayoutalter" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.totalItem()) + " Itens", 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_row, { class: "ion-align-items-center font-montserrat" }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_col, { size: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_swiper, {
              slidesPerView: 3,
              spaceBetween: 30,
              centeredSlides: false
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pedido.product_items, (produto, index) => {
                  return (_openBlock(), _createBlock(_component_swiper_slide, {
                    key: index,
                    class: "produto"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_badge, { class: "cartqtd" }, {
                            default: _withCtx(() => [
                              _createTextVNode("x" + _toDisplayString(produto.quantity), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_ion_col, {
                            class: "ion-text-center produto-imagem",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                width: "70",
                                class: "produto-imagem",
                                src: _ctx.baseURL+'/produto/image/'+ produto.product_id
                              }, null, 8, _hoisted_5)
                            ]),
                            _: 2
                          }, 1024),
                          _createElementVNode("div", _hoisted_6, _toDisplayString(produto.product_name), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (!_ctx.pedido.recente)
          ? (_openBlock(), _createBlock(_component_ion_col, {
              key: 0,
              size: "12",
              class: "ion-text-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.comprarNovamente())),
                  size: "large",
                  shape: "jau",
                  color: "jauservelayoutalter"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_ion_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_col, {
          class: "font-montserrat-bold layout_blue",
          size: "12"
        }, {
          default: _withCtx(() => [
            _hoisted_8,
            _hoisted_9,
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.pedido.shipments[0].shipping_method.name), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_col, { size: "12" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.pedido.shipments[0].shipping_address.full_name), 1),
            (_ctx.pedido.shipments[0].shipping_address.address1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createTextVNode(_toDisplayString(_ctx.pedido.shipments[0].shipping_address.address1 || "") + ", " + _toDisplayString(_ctx.pedido.shipments[0].shipping_address.c_addressNumber || "") + " " + _toDisplayString(_ctx.pedido.shipments[0].shipping_address.address2 || "") + " ", 1),
                  _hoisted_13,
                  _createTextVNode(_toDisplayString(_ctx.pedido.shipments[0].shipping_address.c_neighborhood || "") + ", " + _toDisplayString(_ctx.pedido.shipments[0].shipping_address.city || "") + " - " + _toDisplayString(_ctx.pedido.shipments[0].shipping_address.state_code || ""), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_col, {
          class: "font-montserrat-bold layout_blue top_border",
          size: "12"
        }, {
          default: _withCtx(() => [
            _hoisted_14,
            _hoisted_15
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_row, { size: "12" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.pedido.payment_instruments[0].method_name), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_col, {
          class: "font-montserrat-bold layout_blue top_border",
          size: "12"
        }, {
          default: _withCtx(() => [
            _hoisted_17,
            _hoisted_18
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_row, {
          class: "font-montserrat-l",
          size: "12"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_col, {
              class: "font-montserrat ion-text-end",
              size: "8"
            }, {
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 1
            }),
            _createVNode(_component_ion_col, {
              class: "font-montserrat-l ion-text-end",
              size: "4"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$cart.currencyUSD(_ctx.pedido.product_total)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_ion_col, {
              class: "font-montserrat ion-text-end",
              size: "8"
            }, {
              default: _withCtx(() => [
                _hoisted_20
              ]),
              _: 1
            }),
            _createVNode(_component_ion_col, {
              class: "font-montserrat-l ion-text-end",
              size: "4"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$cart.currencyUSD(_ctx.pedido.shipping_total)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_ion_col, {
              class: "font-montserrat ion-text-end",
              size: "8"
            }, {
              default: _withCtx(() => [
                _hoisted_21
              ]),
              _: 1
            }),
            _createVNode(_component_ion_col, {
              class: "font-montserrat-l ion-text-end",
              size: "4"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$cart.currencyUSD(_ctx.pedido.order_total)), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_row, {
      class: _normalizeClass({ 'disable-op': _ctx.getAvaliacao(_ctx.pedido.current_rating).uuid })
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_col, {
          class: "font-montserrat-bold layout_blue top_border",
          size: "12"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_icon, { icon: _ctx.star }, null, 8, ["icon"]),
            _hoisted_22
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class"]),
    (!_ctx.pedido.recente)
      ? (_openBlock(), _createBlock(_component_ion_row, {
          key: 0,
          class: _normalizeClass(["ion-align-items-center", { 'disable-op': _ctx.getAvaliacao(_ctx.pedido.current_rating).uuid }])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_col, {
              size: !_ctx.getAvaliacao(_ctx.pedido.current_rating).uuid ? '9':'12',
              class: "ont-montserrat"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Olá, " + _toDisplayString(_ctx.store.user.info.name) + ", " + _toDisplayString(!_ctx.getAvaliacao(_ctx.pedido.current_rating).uuid?'deu tudo certo com seu pedido? Conta pra gente.':'obrigado pela avaliação, sua opinião é muito importante para nós.'), 1)
              ]),
              _: 1
            }, 8, ["size"]),
            (!_ctx.getAvaliacao(_ctx.pedido.current_rating).uuid)
              ? (_openBlock(), _createBlock(_component_ion_col, {
                  key: 0,
                  size: "3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.avaliar())),
                      size: "large",
                      color: "jauservelayoutalter",
                      disabled: _ctx.getAvaliacao(_ctx.pedido.current_rating).uuid
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.getAvaliacao(_ctx.pedido.current_rating).uuid ? '':'Avaliar'), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_col, {
                  class: "font-montserrat-bold layout_blue",
                  size: "12"
                }, {
                  default: _withCtx(() => [
                    _hoisted_23
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_col, { size: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      size: "small",
                      color: _ctx.getAvaliacao(_ctx.pedido.current_rating).nota_geral > 0 ? 'jauservelayoutalter':'light',
                      fill: "clear"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, { icon: _ctx.star }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["color"]),
                    _createVNode(_component_ion_button, {
                      size: "small",
                      color: _ctx.getAvaliacao(_ctx.pedido.current_rating).nota_geral > 1 ? 'jauservelayoutalter':'light',
                      fill: "clear"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, { icon: _ctx.star }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["color"]),
                    _createVNode(_component_ion_button, {
                      size: "small",
                      color: _ctx.getAvaliacao(_ctx.pedido.current_rating).nota_geral > 2 ? 'jauservelayoutalter':'light',
                      fill: "clear"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, { icon: _ctx.star }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["color"]),
                    _createVNode(_component_ion_button, {
                      size: "small",
                      color: _ctx.getAvaliacao(_ctx.pedido.current_rating).nota_geral > 3 ? 'jauservelayoutalter':'light',
                      fill: "clear"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, { icon: _ctx.star }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["color"]),
                    _createVNode(_component_ion_button, {
                      size: "small",
                      color: _ctx.getAvaliacao(_ctx.pedido.current_rating).nota_geral > 4 ? 'jauservelayoutalter':'light',
                      fill: "clear"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, { icon: _ctx.star }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["color"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_col, {
                  class: "font-montserrat-bold layout_blue",
                  size: "12"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Como você avalia a " + _toDisplayString(_ctx.pedido.shipments[0].shipping_method.name.toLowerCase()=="receba em casa"?'entrega':"retirada na loja") + "? ", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_col, { size: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      size: "small",
                      color: _ctx.getAvaliacao(_ctx.pedido.current_rating).nota_entrega > 0 ? 'jauservelayoutalter':'light',
                      fill: "clear"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, { icon: _ctx.star }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["color"]),
                    _createVNode(_component_ion_button, {
                      size: "small",
                      color: _ctx.getAvaliacao(_ctx.pedido.current_rating).nota_entrega > 1 ? 'jauservelayoutalter':'light',
                      fill: "clear"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, { icon: _ctx.star }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["color"]),
                    _createVNode(_component_ion_button, {
                      size: "small",
                      color: _ctx.getAvaliacao(_ctx.pedido.current_rating).nota_entrega > 2 ? 'jauservelayoutalter':'light',
                      fill: "clear"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, { icon: _ctx.star }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["color"]),
                    _createVNode(_component_ion_button, {
                      size: "small",
                      color: _ctx.getAvaliacao(_ctx.pedido.current_rating).nota_entrega > 3 ? 'jauservelayoutalter':'light',
                      fill: "clear"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, { icon: _ctx.star }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["color"]),
                    _createVNode(_component_ion_button, {
                      size: "small",
                      color: _ctx.getAvaliacao(_ctx.pedido.current_rating).nota_entrega > 4 ? 'jauservelayoutalter':'light',
                      fill: "clear"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, { icon: _ctx.star }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["color"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_col, {
                  class: "font-montserrat-bold layout_blue",
                  size: "12"
                }, {
                  default: _withCtx(() => [
                    _hoisted_24
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_col, { size: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      size: "small",
                      color: _ctx.getAvaliacao(_ctx.pedido.current_rating).nota_aplicativo > 0 ? 'jauservelayoutalter':'light',
                      fill: "clear"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, { icon: _ctx.star }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["color"]),
                    _createVNode(_component_ion_button, {
                      size: "small",
                      color: _ctx.getAvaliacao(_ctx.pedido.current_rating).nota_aplicativo > 1 ? 'jauservelayoutalter':'light',
                      fill: "clear"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, { icon: _ctx.star }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["color"]),
                    _createVNode(_component_ion_button, {
                      size: "small",
                      color: _ctx.getAvaliacao(_ctx.pedido.current_rating).nota_aplicativo > 2 ? 'jauservelayoutalter':'light',
                      fill: "clear"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, { icon: _ctx.star }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["color"]),
                    _createVNode(_component_ion_button, {
                      size: "small",
                      color: _ctx.getAvaliacao(_ctx.pedido.current_rating).nota_aplicativo > 3 ? 'jauservelayoutalter':'light',
                      fill: "clear"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, { icon: _ctx.star }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["color"]),
                    _createVNode(_component_ion_button, {
                      size: "small",
                      color: _ctx.getAvaliacao(_ctx.pedido.current_rating).nota_aplicativo > 4 ? 'jauservelayoutalter':'light',
                      fill: "clear"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, { icon: _ctx.star }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["color"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.getAvaliacao(_ctx.pedido.current_rating).comentario!='')
              ? (_openBlock(), _createBlock(_component_ion_col, {
                  key: 1,
                  class: "ion-text-center",
                  size: "12"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_textarea, {
                      class: "textareaavaliado",
                      modelValue: _ctx.getAvaliacao(_ctx.pedido.current_rating).comentario,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.getAvaliacao(_ctx.pedido.current_rating).comentario) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class"]))
      : (_openBlock(), _createBlock(_component_ion_row, {
          key: 1,
          class: "ion-align-items-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_col, {
              class: "font-montserrat-bold",
              size: "12"
            })
          ]),
          _: 1
        }))
  ], 64))
}